export const START_EDITING = 'START_EDITING';
export const CHANGE_FORM_DATA = 'CHANGE_FORM_DATA';
